import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { ParallaxBackground } from './ParallaxBackground';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen relative">
      <ParallaxBackground />
      <Navbar />
      <main className="relative z-10">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
